<template>
  <pt-award-audit-detail class="pt-points-reward-detail__withData" :pointsRewardsDetail="pointsRewardsDetail" :detailLoading="detailLoading"></pt-award-audit-detail>
</template>

<script>
import PtAwardAuditDetail from './index'
export default {
  name: 'pt-points-reward-detail__withData',
  components: {
    'pt-award-audit-detail': PtAwardAuditDetail
  },
  data () {
    return {
      pointsRewardsDetail: {},
      detailLoading: false
    }
  },
  methods: {
    getPointsRewardsDetail () {
      this.detailLoading = true
      this.$store.dispatch('getPointsRewardsDetail', this.$route.params.id).then(res => {
        this.detailLoading = false
        this.pointsRewardsDetail = res
      }).catch(err => {
        this.detailLoading = false
        this.$message.error(err || '获取奖励积分详情失败')
      })
    }
  },
  created () {
    this.getPointsRewardsDetail()
  }
}
</script>
